<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <TextEditor
          title="Message"
          v-model="value.message"
          :table="table"
          :component="component"
          :containers="containers"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TextEditor from "../shared/TextEditor.vue";

export default {
  name: "AlertDesigner",

  components: { TextEditor },

  props: ["value", "table", "component", "containers"],
};
</script>
